export default __webpack_public_path__ + "static/media/50-beaches.53ac1062.mp4";